<div class="modal-overlay">
  <mat-dialog-content>
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-container modal-title">{{ data?.nameGroup }}</h2>
        <button class="close-button" (click)="close()">
          <span>&times;</span>
        </button>
      </div>
      <div class="loading-container" *ngIf="isLoading">
        <p>Carregando taxas...</p>
      </div>

      <ng-template #campaignTemplate let-campaign="campaign">

        <div class="anticipation-fee" *ngIf="campaign.hasMdrRate && campaign.mdrWithPrepayment">
          <p class="fd-subtitle">Taxa de antecipação automática</p>

          <table mat-table [dataSource]="[{}]" class="fd-table">
            <ng-container matColumnDef="maxAnnualBilling" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header">Faturamento anual</th>
              <td mat-cell *matCellDef="let row">{{ campaign.autoPrepayment?.maxAnnualBilling | currency: 'BRL' }}</td>
            </ng-container>


            <ng-container matColumnDef="suggestedAutoPrepayment" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fd-table__header">Taxa/Mês</th>
              <td mat-cell *matCellDef="let row">{{ campaign.autoPrepayment?.suggestedAutoPrepayment | percent }}</td>
            </ng-container>

            <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="anticipationFeesDisplayedColumns"></tr>
            <tr mat-row class="fd-table__row" *matRowDef="let row; columns: anticipationFeesDisplayedColumns"></tr>
          </table>
        </div>

        <div class="mdr-or-mdrFlex-table-container" *ngIf="campaign.mdrRateDataSource?.length > 0 || campaign.mdrFlexRateDataSource?.length > 0">
          <table mat-table [dataSource]="campaign.hasMdrRate ? campaign.mdrRateDataSource : campaign.mdrFlexRateDataSource" class="fd-table fee-table">
            <ng-container matColumnDef="bandeira" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header">Bandeira</th>
              <td mat-cell *matCellDef="let rowElement">
                <img [class]="rowElement.bandeira" [src]="getBrandLogo(rowElement.bandeira)" [alt]="rowElement.bandeira" class="brand-logo"/>
              </td>
            </ng-container>
            <ng-container matColumnDef="debito" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header align-center">Débito</th>
              <td class="align-center" mat-cell *matCellDef="let rowElement">{{ rowElement.debito | percent }}</td>
            </ng-container>
            <ng-container matColumnDef="credito" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header align-center">Crédito</th>
              <td class="align-center" mat-cell *matCellDef="let rowElement">{{ rowElement.credito | percent }}</td>
            </ng-container>
            <ng-container matColumnDef="parcelamentoAte6x" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header align-center">Parcelamento em até 6x</th>
              <td class="align-center" mat-cell *matCellDef="let rowElement">{{ rowElement.parcelamentoAte6x | percent }}</td>
            </ng-container>
            <ng-container matColumnDef="parcelamentoMais6x" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header align-center">Parcelamento mais de 6x</th>
              <td class="align-center" mat-cell *matCellDef="let rowElement">{{ rowElement.parcelamentoMais6x | percent }}</td>
            </ng-container>
            <ng-container matColumnDef="crediario" class="fd-table__cell">
              <th mat-header-cell *matHeaderCellDef class="fd-table__header align-center">Crediário</th>
              <td class="align-center" mat-cell *matCellDef="let rowElement">{{ rowElement.crediario | percent }}</td>
            </ng-container>
            <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="fd-table__row" *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>

        <div *ngIf="campaign.availableTechnologies?.length > 0" class="technology-table-container">
          <p class="fd-subtitle">Tecnologias Disponíveis</p>
          <app-technology-price-table class="center-table" [data]="campaign.availableTechnologies"></app-technology-price-table>
        </div>
      </ng-template>

      <ng-container *ngIf="campaignTabs?.length > 1; else singleCampaign">
        <mat-tab-group>
          <mat-tab *ngFor="let tab of campaignTabs"  [label]="tab.description">
            <div class="tab-content">
              <ng-container
                [ngTemplateOutlet]="campaignTemplate"
                [ngTemplateOutletContext]="{ campaign: tab }">
              </ng-container>
            </div>
          </mat-tab>
        </mat-tab-group>
      </ng-container>

      <ng-template #singleCampaign>
        <ng-container *ngIf="campaignTabs?.length === 1">
          <ng-container
            [ngTemplateOutlet]="campaignTemplate"
            [ngTemplateOutletContext]="{ campaign: campaignTabs[0] }">
          </ng-container>
        </ng-container>
      </ng-template>

      <div *ngIf="!isLoading && campaignTabs?.length === 0" class="no-data">
        <p>Nenhuma campanha com taxas disponíveis.</p>
      </div>
    </div>
  </mat-dialog-content>
</div>
